import { render, staticRenderFns } from "./HomeFollowedTopics.vue?vue&type=template&id=e0a57728&scoped=true"
import script from "./HomeFollowedTopics.vue?vue&type=script&lang=js"
export * from "./HomeFollowedTopics.vue?vue&type=script&lang=js"
import style0 from "./HomeFollowedTopics.vue?vue&type=style&index=0&id=e0a57728&prod&scoped=true&lang=css"
import style1 from "./HomeFollowedTopics.vue?vue&type=style&index=1&id=e0a57728&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a57728",
  null
  
)

export default component.exports